var array = Array.prototype;

export var map = array.map;
export var slice = array.slice;



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-scale/src/array.js
// module id = spl9
// module chunks = 0